/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmPostDto } from '../models/ConfirmPostDto';
import type { ConfirmPostResponseDto } from '../models/ConfirmPostResponseDto';
import type { CreateFromUploadResponseDto } from '../models/CreateFromUploadResponseDto';
import type { CreateProjectDto } from '../models/CreateProjectDto';
import type { CreateProjectResponseDto } from '../models/CreateProjectResponseDto';
import type { PreviewSiblingsDto } from '../models/PreviewSiblingsDto';
import type { PreviewSiblingsResponseDto } from '../models/PreviewSiblingsResponseDto';
import type { ProjectEntity } from '../models/ProjectEntity';
import type { ProjectWithCreativesResponseDto } from '../models/ProjectWithCreativesResponseDto';
import type { RegenerateCreativeRequestDto } from '../models/RegenerateCreativeRequestDto';
import type { RegenerateCreativeResponseDto } from '../models/RegenerateCreativeResponseDto';
import type { RetryNowDto } from '../models/RetryNowDto';
import type { RetryNowResponseDto } from '../models/RetryNowResponseDto';
import type { UpdateUserMediaDto } from '../models/UpdateUserMediaDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectService {
    /**
     * Bring-your-own-content: replace the uploaded media on a BYO post (the composer's tray). All platform creatives swap together; captions and other words are preserved. Blocked once any platform has published.
     * @param id Project ID
     * @param requestBody
     * @returns CreateFromUploadResponseDto
     * @throws ApiError
     */
    public static projectControllerUpdateUserMediaV1(
        id: string,
        requestBody: UpdateUserMediaDto,
    ): CancelablePromise<CreateFromUploadResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/projects/{id}/user-media',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create a new project with creatives
     * @param requestBody
     * @returns CreateProjectResponseDto
     * @throws ApiError
     */
    public static projectControllerCreateV1(
        requestBody: CreateProjectDto,
    ): CancelablePromise<CreateProjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List projects for the current user; optionally filter by kind
     * @param kind
     * @returns ProjectEntity
     * @throws ApiError
     */
    public static projectControllerFindAllV1(
        kind: string,
    ): CancelablePromise<Array<ProjectEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects',
            query: {
                'kind': kind,
            },
        });
    }
    /**
     * Get a project with its creatives
     * @param id Project ID
     * @returns ProjectWithCreativesResponseDto
     * @throws ApiError
     */
    public static projectControllerFindOneV1(
        id: string,
    ): CancelablePromise<ProjectWithCreativesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Delete a project
     * @param id Project ID
     * @returns any
     * @throws ApiError
     */
    public static projectControllerDeleteV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/projects/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Confirm a suggested Post and fan out variants to the selected platforms
     * @param id Post (Project) ID
     * @param requestBody
     * @returns ConfirmPostResponseDto
     * @throws ApiError
     */
    public static projectControllerConfirmPostV1(
        id: string,
        requestBody: ConfirmPostDto,
    ): CancelablePromise<ConfirmPostResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{id}/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Immediately re-publish failed creatives (recovery). Clears the failure marker, schedules for now, and enqueues the publish job — the processor + Pusher drive the live update and heal-on-success.
     * @param requestBody
     * @returns RetryNowResponseDto
     * @throws ApiError
     */
    public static projectControllerRetryNowV1(
        requestBody: RetryNowDto,
    ): CancelablePromise<RetryNowResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/retry-now',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Eagerly create draft sibling creatives so PostModal can render platform-faithful previews before confirm. Idempotent.
     * @param id Post (Project) ID
     * @param requestBody
     * @returns PreviewSiblingsResponseDto
     * @throws ApiError
     */
    public static projectControllerPreviewSiblingsV1(
        id: string,
        requestBody: PreviewSiblingsDto,
    ): CancelablePromise<PreviewSiblingsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{id}/preview-siblings',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Discard a suggested Post
     * @param id Post (Project) ID
     * @returns any
     * @throws ApiError
     */
    public static projectControllerDiscardPostV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{id}/discard',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Regenerate a suggested Post's primary creative. Appends to the variant history; client navigates with prev/next. Optional `userDirection` body steers the agent's rewrite (copy + image).
     * @param id Post (Project) ID
     * @param requestBody
     * @returns RegenerateCreativeResponseDto
     * @throws ApiError
     */
    public static projectControllerRegenerateCreativeV1(
        id: string,
        requestBody: RegenerateCreativeRequestDto,
    ): CancelablePromise<RegenerateCreativeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{id}/regenerate-creative',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
